import React, { useState, useRef, useEffect } from "react";
import { getUniqueCurrencies, getCurrencyFlag } from "../constants/currencies";
import "../../styles-v2/dropdown/v2-currency-dropdown.css";

const CurrencyDropdown = ({ isOpen, onClose, onSelect, selectedCurrency, currencies = [] }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  // Get all available currencies from constants
  const allCurrencies = getUniqueCurrencies();

  const filteredCurrencies = allCurrencies.filter((currency) =>
    currency.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
    currency.value.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleReset = () => {
    // Reset to INR (Indian Rupee) as default
    const defaultOldFormat = allCurrencies.find((currency) => currency.value === "INR") || allCurrencies[0];
    const defaultCurrency = currencies.find((c) => c.code === defaultOldFormat.value) || currencies[0];
    onSelect(defaultCurrency);
    setSearchTerm("");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="v2-currency-dropdown" ref={dropdownRef}>
      <div className="v2-currency-dropdown__header">
        <h3 className="v2-currency-dropdown__title">Select Currency</h3>
        <button
          className="v2-currency-dropdown__reset"
          onClick={handleReset}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
            <path d="M21 3v5h-5" />
            <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" />
            <path d="M3 21v-5h5" />
          </svg>
          Reset Filter
        </button>
      </div>

      <div className="v2-currency-dropdown__search">
        <input
          type="text"
          placeholder="Search currency..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="v2-currency-dropdown__search-input"
        />
      </div>

      <div className="v2-currency-dropdown__list">
        {filteredCurrencies.map((currency, index) => {
          const flag = getCurrencyFlag(currency.label);
          const isSelected = selectedCurrency?.code === currency.value;

          return (
            <button
              key={`${currency.value}-${index}`}
              className={`v2-currency-dropdown__item ${isSelected ? "v2-currency-dropdown__item--selected" : ""
                }`}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();

                // Map old format to new format
                const contextCurrency = currencies.find((c) => c.code === currency.value);

                if (contextCurrency) {
                  onSelect(contextCurrency);
                  onClose();
                  setSearchTerm("");
                } else {
                  // Fallback to INR if currency not found (shouldn't happen)
                  console.warn(`Currency ${currency.value} not found in context, using INR as fallback`);
                  const fallback = currencies.find((c) => c.code === "INR") || currencies[0];
                  if (fallback) {
                    onSelect(fallback);
                    onClose();
                    setSearchTerm("");
                  }
                }
              }}
            >
              <span className="v2-currency-dropdown__flag">{flag}</span>
              <span className="v2-currency-dropdown__code">
                {currency.value}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CurrencyDropdown;
